<template>
  <b-modal :id="modalId" size="md" modal-class="modal-manage-view">
    <h5>{{ $t(config.label) }}</h5>
    <div class="wrapper p-2">
      <FormulateForm
        ref="formRef"
        v-model="formValues"
        class="my-1"
        @validation="handleFormValidation"
      >
        <InputTableFilter
          ref="inputTableFilter"
          :formValues="formValues"
          :fullObjects="fullObjects"
          :parameter="parameter"
          :config="config"
          @update:formValues="updateFormValues($event)"
          @update:fullObjects="updateFullObjects($event)"
        />
      </FormulateForm>
    </div>
    <template #modal-header>
      <b-row>
        <b-col md="8">
          <span class="__title"> {{ title ?? $t('dashboard.title.filter') }} </span>
        </b-col>
        <b-col md="4">
          <a class="reset-button" href="#" @click.prevent="resetFilters">{{
            $t('global.action.resetFilter')
          }}</a>
        </b-col>
      </b-row>
    </template>
    <template #modal-footer>
      <b-row class="modal__footer mx-0">
        <b-col sm="12" md="12" class="modal__footer-btn">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.cancel')"
            @click="cancelFilter"
          />
          <McButton
            variant="primary"
            :text="$t('global.apply')"
            :disabled="formHasErrors"
            @click="handleAccept"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import InputTableFilter from './components/InputTableFilter'

export default {
  components: {
    InputTableFilter,
    McButton,
  },
  mixins: [Helper],
  props: {
    config: {
      type: Object,
      required: true,
    },
    parameter: {
      type: String,
      default: 'filter',
    },
    title: {
      type: String,
      default: null,
    },
  },
  emits: ['refresh-table'],
  data() {
    return {
      modalId:
        this.parameter == 'additionalFilter'
          ? this.config.modal + '-additional-filter'
          : this.config.modal,
      showModal: false,
      filter: {},
      formValues: {},
      fullObjects: {},
      tempModel: {},
      formHasErrors: false,
      vehicleTypes: {
        vehicleTypes: [],
      },
      vgroups: {
        vgroups: [],
      },
      parameterFilter: this.config[this.parameter] ?? this.config.filter,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
  },
  mounted() {
    this.filter = this.parameterFilter ?? {}
  },
  methods: {
    handleFormValidation() {
      this.formHasErrors = this.$refs.formRef?.hasErrors || false
    },
    async SetFormValues(model) {
      this.tempModel = { ...model }
      let { fullObjects, ...otherFilter } = this.tempModel
      this.formValues = { ...otherFilter }
      this.fullObjects = { ...fullObjects }
      setTimeout(() => {
        this.$refs.inputTableFilter.loadDataFilter({
          vehicleTypeId: this.formValues.vehicleTypeId,
          vehicleGroupId: this.formValues.vehicleGroupId,
        })
      }, 300)
    },
    getRequiredField(key) {
      return this.parameterFilter[key].required
    },
    updateFormValues({ key, value }) {
      this.$set(this.formValues, key, value)
    },
    updateFullObjects({ key, value }) {
      this.$set(this.fullObjects, key, value)
    },
    resetForm() {
      this.formValues = {}
      this.fullObjects = {}
    },
    resetFilters() {
      this.formValues = {}
      this.fullObjects = {}
    },
    cancelFilter() {
      this.resetForm()
      this.$bvModal.hide(this.modalId)
    },
    handleAccept() {
      const formValues = this.formValues
      const filter = {
        ...formValues,
      }
      const filterValue = {
        ...formValues,
        fullObjects: this.fullObjects,
      }
      this.filter = filter
      if (this.validateFilterReport()) {
        let finalFilter = {}
        Object.keys(filter).forEach((key) => {
          if (filter[key] !== null) finalFilter[key] = filter[key]
        })

        if (finalFilter.vehicleTypeId)
          finalFilter.vehicleTypeId = Array.isArray(finalFilter.vehicleTypeId)
            ? finalFilter.vehicleTypeId.map((item) => parseInt(item))
            : parseInt(finalFilter.vehicleTypeId)

        if (finalFilter.vehicleGroupId)
          finalFilter.vehicleGroupId = Array.isArray(finalFilter.vehicleGroupId)
            ? finalFilter.vehicleGroupId.map((item) => parseInt(item))
            : parseInt(finalFilter.vehicleGroupId)

        this.$store.commit('dashboard/updateFilter', finalFilter)
        this.$store.commit('dashboard/updateFilterValue', filterValue)
        this.saveReportFilter(filterValue, finalFilter, this.config.key)
        this.saveFilterDetail(filterValue.fullObjects)

        this.resetForm()
        this.$emit('refresh-table')
        this.$bvModal.hide(this.modalId)
      }
    },
    saveFilterDetail(fullObject) {
      const keys = Object.keys(fullObject)
      const data = {}
      keys.forEach((key) => {
        if (key == 'vehicleTypeId') {
          if (Array.isArray(fullObject.vehicleTypeId)) {
            let vehicleType =
              fullObject.vehicleTypeId.length > 0 ? fullObject.vehicleTypeId[0].type : '-'
            vehicleType +=
              fullObject.vehicleTypeId.length > 1 ? `, ${fullObject.vehicleTypeId[1].type}` : ''
            data.vehicleType = vehicleType
          } else {
            data.vehicleType = fullObject.vehicleTypeId.type
          }
        } else if (key == 'vehicleGroupId') {
          if (Array.isArray(fullObject.vehicleGroupId)) {
            let groupName =
              fullObject.vehicleGroupId.length > 0 ? fullObject.vehicleGroupId[0].name : '-'
            groupName +=
              fullObject.vehicleGroupId.length > 1 ? `, ${fullObject.vehicleGroupId[1].name}` : ''
            data.groupName = groupName
          } else {
            data.groupName = fullObject.vehicleGroupId.name
          }
        }
      })
      this.setReportDetail(this.config.key, { ...data })
    },
    validateFilterReport() {
      const filterReport = this.parameterFilter
      let messageError = ''
      for (const item of Object.keys(this.filter)) {
        if (
          filterReport[item] &&
          filterReport[item].required &&
          (!this.filter[item] || this.filter[item].length <= 0)
        ) {
          if (item == 'vehicleTypeId') {
            messageError = `${this.$t('dashboard.object.vehicleType')} ${this.$t(
              'global.validation.required'
            )}`
          } else if (item == 'vehicleGroupId') {
            messageError = `${this.$t('dashboard.object.vehicleGroup')} ${this.$t(
              'global.validation.required'
            )}`
          }
          break
        }
      }
      return true
    },

    transformFilterInterval(interval) {
      const intervalData = {}
      intervalData[interval] = true
      return intervalData
    },

    filterIntervalData(interval) {
      this.intervalData = {}
      this.intervalData[interval] = true
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.modal-manage-view) {
  .modal-dialog {
    border-radius: 0px;
    max-height: 100vh;
    height: 100%;
    margin: 0;
    margin-left: auto;
  }

  .modal-content {
    height: 100%;
  }

  .modal-content,
  .modal-header,
  .modal-footer {
    border-radius: 0;

    .modal__footer-btn {
      display: flex;
    }
  }

  .modal-header {
    color: $white;
    justify-content: space-between;

    .__reset {
      font-size: 13px;
      text-align: right;
      cursor: pointer;
    }
  }

  .modal-body {
    flex: 1;
    overflow-y: auto;
    min-height: 0; /* critical! without this, flex won't shrink */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
  }

  .modal-body::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }

  .wrapper {
    // overflow-y: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.section {
  :deep(input[type='checkbox']) {
    margin-bottom: 2px;
  }

  & > p {
    color: $teal-300;
    font-weight: 600;
  }

  &-information {
    &__content {
      border: 2px solid $blue-100;
      border-radius: 4px;
      margin-bottom: 20px;

      & > p {
        display: flex;
        gap: 5px;
        align-items: center;
        margin-bottom: 0;

        &:first-child {
          margin-bottom: 4px;
        }
      }
    }
  }

  &-column-manager {
    overflow: hidden;
    flex: 1 1 auto;

    &__content {
      box-shadow: 0px 5px 15px 0px rgba(13, 68, 145, 0.08);
      overflow-y: hidden;
      height: 100%;
    }

    &__header {
      button {
        background: transparent;
        border: none;
        color: $cyan;
        font-weight: 600;
      }
    }

    &__draggable {
      background: $gray;
      padding: 16px;
      overflow-y: auto;
      height: 100%;
      padding-bottom: 86px;

      &-item {
        cursor: move;
        background: white;
        margin-bottom: 16px;
        border-radius: 5px;
        padding: 14px 12px;
        transition: 0.3s;

        .__divider {
          background-color: $teal-100;
          height: 16px;
          width: 1px;
        }
      }
    }
  }
}

.icon-outline_move {
  color: $blue-400;
  font-size: 16px;
}

.reset-button {
  background: transparent;
  border: none;
  color: $white;
  float: right;
}
</style>
